<script>
    import SmartFilterEditHeader from '@/components/page-smart-filter/smart-filter-edit/SmartFilterEditHeader.vue';
    import SmartFilterDataMain from '@/components/page-smart-filter/SmartFilterDataMain.vue';
    import SmartFilterDataProviderAndGame from '@/components/page-smart-filter/SmartFilterDataProviderAndGame.vue';
    import SmartFilterDataFilter from '@/components/page-smart-filter/SmartFilterDataFilter.vue';
    import SmartFilterDataTag from '@/components/page-smart-filter/SmartFilterDataTag.vue';
    import SmartFilterDataSearch from '@/components/page-smart-filter/SmartFilterDataSearch.vue';

    import { changeData } from '@/scripts/tools.js';

    export default {
        data() {
            return {
                errorText: '',
            } 
        },
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_SMART_FILTER_EDIT},
            editData() {return this.$store.getters.SMART_FILTER_DATA_EDIT},
        },
        components: {
            SmartFilterEditHeader: SmartFilterEditHeader,
            SmartFilterDataMain: SmartFilterDataMain,
            SmartFilterDataProviderAndGame: SmartFilterDataProviderAndGame,
            SmartFilterDataFilter: SmartFilterDataFilter,
            SmartFilterDataTag: SmartFilterDataTag,
            SmartFilterDataSearch: SmartFilterDataSearch,
        },
        methods: {
            async updateData(event, fieldName, isCheckBox = false, isSetValue = false) {
                this.errorText = await changeData(
                    event, fieldName, 'SMART_FILTER_DATA_EDIT_UPDATE', 'CHECK_SMART_FILTER_EDIT', isCheckBox, isSetValue
                );
            },
            async pushData(value, fieldName) {
                this.$store.commit('SMART_FILTER_DATA_EDIT_PUSH',{
                    fieldName: fieldName,
                    fieldValue: value,
                });
            },
            async spliceData(value, fieldName) {
                this.$store.commit('SMART_FILTER_DATA_EDIT_SPLICE',{
                    fieldName: fieldName,
                    fieldValue: value,
                });
            }
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <SmartFilterEditHeader />
        <hr class="hr_light_98">
        <div class="left_sub_panel_data mb_10">
            <label
                v-if="errorText !== ''"
                class="error_text mt_10"
            >{{ errorText }}</label>
        </div>

        <SmartFilterDataMain 
            :data="editData"
            :updateData="updateData"
        />
        <hr class="hr_light_98">
        <SmartFilterDataProviderAndGame 
            :data="editData"
            :pushData="pushData"
            :spliceData="spliceData"
        />
        <hr class="hr_light_98">
        <SmartFilterDataFilter 
            :data="editData"
            :pushData="pushData"
            :spliceData="spliceData"
        />
        <hr class="hr_light_98">
        <SmartFilterDataTag 
            :data="editData"
            :updateData="updateData"
        />
        <hr class="hr_light_98">
        <SmartFilterDataSearch 
            :data="editData"
            :updateData="updateData"
        />
    </div>
</template>